'use strict';
import angular from 'angular';
import './scripts/calendar.ctrls';
import './scripts/calendar.services';

import slotsHtmlUrl from './views/slots.html';
import slotTypesHtmlUrl from './views/slotTypes.html';
import slotMappingHtmlUrl from './views/slotMapping.html';

angular.module('calendar', [
    'calendar.ctrls',
    'calendar.services'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('calendarSlots', {
                parent: 'layout',
                url: '/admin/calendar/slots',
                templateUrl: slotsHtmlUrl,
                controller: 'SlotsController'
            })
            .state('calendarSlotTypes', {
                parent: 'layout',
                url: '/admin/calendar/slotTypes',
                templateUrl: slotTypesHtmlUrl,
                controller: 'SlotTypeController'
            })
            .state('calendarSlotMappingsBySlotType', {
                parent: 'layout',
                url: '/admin/calendar/slotMappings/:slotTypeId',
                templateUrl: slotMappingHtmlUrl,
                controller: 'SlotMappingController'
            })
    }]);